import React, { useEffect, createElement } from 'react';
import AdvertorialGlpPlateau4 from '../components/AdvertorialGlpPlateau4';
import { HelmetProvider, Helmet } from 'react-helmet-async';
declare global {
  interface Window {
    fbq: any;
  }
}
export function GlpPlateau4Page() {
  useEffect(() => {
    !function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', '9567705179928833');
    window.fbq('track', 'PageView');
    window.fbq('track', 'ViewContent', {
      content_name: 'GLP-1 Plateau Investigation',
      content_category: 'Health',
      content_type: 'article'
    });
    const params = new URLSearchParams(window.location.search);
    const fbclid = params.get('fbclid');
    if (fbclid) {
      localStorage.setItem('fbclid', fbclid);
    }
    let tracked50 = false;
    let tracked90 = false;
    const handleScroll = () => {
      const scrollPercent = window.scrollY / (document.body.scrollHeight - window.innerHeight) * 100;
      if (!tracked50 && scrollPercent > 50) {
        window.fbq('trackCustom', 'Advertorial_Scroll_50');
        tracked50 = true;
      }
      if (!tracked90 && scrollPercent > 90) {
        window.fbq('trackCustom', 'Advertorial_Scroll_90');
        tracked90 = true;
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return <HelmetProvider data-id="element-18675" data-mp="2yibli9pvt0ie">
      <div className="w-full min-h-screen bg-gray-100" data-id="element-18676" data-mp="2yhtkkzs9xy45">
        <Helmet data-id="element-18677" data-mp="2ykem1nonuc1d">
          <title data-id="element-18678" data-mp="2uh9n1v3sgshh">
            Dr. Hogan: The Hidden Syndrome Affecting Up To 3 Million GLP-1
            Users... Maybe Even You
          </title>
          <meta property="og:title" content="Dr. Hogan: The Hidden Syndrome Affecting Up To 3 Million GLP-1 Users... Maybe Even You" data-id="element-18679" data-mp="38icb2decgcv1" />
          <meta property="og:description" content="The Dopamine Problem Researchers Just Discovered In GLP-1 Users—And The Breakthrough Protocol That's Bringing Back Joy Without Stopping The Weight Loss" data-id="element-18680" data-mp="33k0xbrkxhi7j" />
          <meta property="og:type" content="article" data-id="element-18681" data-mp="3r793ebq6kvam" />
          <meta property="og:url" content={window.location.href} data-id="element-18682" data-mp="3r6qzqu16veso" />
          <meta property="og:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/rj5HPkWXSP8komhpUDQJCG/6OUBdNn4rvjDcxkk8ToP9.jpg" data-id="element-18683" data-mp="3m7nx1g8olknv" />
          <meta property="og:image:width" content="1200" data-id="element-18684" data-mp="50aiyilg85df" />
          <meta property="og:image:height" content="630" data-id="element-18685" data-mp="1qxskeoixm4" />
          <meta property="og:site_name" content="Health Investigation Series" data-id="element-18686" data-mp="3w4is1p5qx2xe" />
          <meta name="twitter:card" content="summary_large_image" data-id="element-18687" data-mp="jniyfvlsiwv7" />
          <meta name="twitter:title" content="Dr. Hogan: The Hidden Syndrome Affecting Up To 3 Million GLP-1 Users... Maybe Even You" data-id="element-18688" data-mp="nnbe0s9lq3a2" />
          <meta name="twitter:description" content="The Dopamine Problem Researchers Just Discovered In GLP-1 Users—And The Breakthrough Protocol That's Bringing Back Joy Without Stopping The Weight Loss" data-id="element-18689" data-mp="9qo47owjvimq" />
          <meta name="twitter:url" content={window.location.href} data-id="element-18690" data-mp="3w2bj3su1412n" />
          <meta name="twitter:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/rj5HPkWXSP8komhpUDQJCG/6OUBdNn4rvjDcxkk8ToP9.jpg" data-id="element-18691" data-mp="4qa36qtd98y7" />
        </Helmet>
        <AdvertorialGlpPlateau4 data-id="element-18692" data-mp="3s21diha5fcob" />
      </div>
    </HelmetProvider>;
}